import { Info } from "@assets";
import { BodySmall } from "@components/Typography";
import { i18n, Translations } from "@i18n";
import { useStyles } from "./styles";

export const VerificationErrorBanner = () => {
  const styles = useStyles();

  return (
    <div style={styles.container}>
      <div style={styles.icon}>
        <Info size={24} />
      </div>
      <div style={styles.content}>
        <BodySmall style={styles.title}>
          {i18n.t(Translations.AccountVerificationErrorTitle)}
        </BodySmall>
        <BodySmall>{i18n.t(Translations.AccountVerificationErrorSubtitle)}</BodySmall>
      </div>
    </div>
  );
};
